export default {
  ENABLED_GOOGLE_OAUTH_CRM: false,
  GOOGLE_OAUTH_CALLBACK_PATH: "/googleOAuth/callback",
};
